export const defaultState = {
  id: null,
  fullName: '',
  email: '',
  course: null,
  courseOption: null,
  name: '',
  completionDate: null,
  cpdHours: '',
  competencies: [],
  competencyOptions: [],
  isProgramme: false,
  programmeSubset: '',
};

const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
